import { useCallback, useRef, useState } from 'react';

/* Pamćenje gde je korisnik stao u pregledu — strana paginatora, sort, pretraga
   i kvačica za neaktivne.

   Zašto ovako: tabovi (Pregled / Unos / Dokumenta) se ne kriju nego se
   odmontiraju, pa lokalni useState nestane čim se ode na Unos. Stanje zato
   živi u mapi na nivou modula — preživi odlazak na drugi tab i povratak, a
   briše se osvežavanjem stranice. Tako "prvi put" korisnik vidi podrazumevani
   prikaz, a posle toga svoj poslednji.

   Ključ nosi i firma_id (vidi pozive), pa promena firme sama vraća podrazumevano. */
const memorija = new Map();

/* [stanje, izmeni] — `izmeni` prima delta objekat ({ first: 20 }) ili funkciju
   nad prethodnim stanjem; svaka izmena se odmah upiše u memoriju. */
const usePamcenjePregleda = (kljuc, podrazumevano) => {
  const [stanje, postaviStanje] = useState(() => memorija.get(kljuc) || podrazumevano);

  /* Ključ se menja kad se promeni firma (ili kad podatak o firmi stigne posle
     prvog rendera) — tada se čita zapamćeno za taj ključ, a ako ga nema,
     vraća se podrazumevano. */
  const prethodniKljuc = useRef(kljuc);
  if (prethodniKljuc.current !== kljuc) {
    prethodniKljuc.current = kljuc;
    postaviStanje(memorija.get(kljuc) || podrazumevano);
  }

  const izmeni = useCallback((delta) => {
    postaviStanje((prev) => {
      const novo = typeof delta === 'function' ? delta(prev) : { ...prev, ...delta };
      memorija.set(kljuc, novo);
      return novo;
    });
  }, [kljuc]);

  return [stanje, izmeni];
};

/* Za slučaj da neko mesto želi da izbriše zapamćeno (npr. posle brisanja zapisa). */
export const obrisiPamcenjePregleda = (kljuc) => memorija.delete(kljuc);

export default usePamcenjePregleda;
